import { PhoneNumberSchema } from '@guiker/phone-number'
import { yup } from '@guiker/yup-util'

const userSchema = yup.object({
  userId: yup.string().notRequired(),
  emailAddress: yup.string().email().required(),
  phone: PhoneNumberSchema(true).required(),
  firstName: yup.string().required(),
  lastName: yup.string().optional(),
})

export const createPropertySaleInquirySchema = yup.object({
  user: userSchema.required(),
  listingId: yup.string().required(),
  recaptchaToken: yup.string().required(),
  assumptions: yup.object(),
  results: yup.object(),
})

export type CreatePropertySaleInquirySchema = yup.InferType<typeof createPropertySaleInquirySchema>
